export const modeOptions = {
  'In-House': 'In House',
  Outsourced: 'OutSourced',
}
